import { render, staticRenderFns } from "./ListIdentitas.vue?vue&type=template&id=4d3a7695&"
import script from "./ListIdentitas.vue?vue&type=script&lang=js&"
export * from "./ListIdentitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports